/**
 * Cronologia del Lead (segnalazione e83a59a3): le task commerciali ancora da svolgere
 * vanno in cima, in ordine di scadenza (le piu' urgenti prima, senza scadenza in fondo);
 * sotto resta la cronologia per giorno con note, task completate e il resto.
 */
export interface TimelineItemLike {
  type: string;
  data: { status?: string | null; due_date?: string | null };
}

export function splitOpenActivities<T extends TimelineItemLike>(items: T[]): { open: T[]; rest: T[] } {
  const open: T[] = [];
  const rest: T[] = [];
  for (const item of items) {
    if (item.type === 'activity' && item.data.status !== 'completed') open.push(item);
    else rest.push(item);
  }
  const due = (i: T) => (i.data.due_date ? new Date(i.data.due_date).getTime() : Number.POSITIVE_INFINITY);
  open.sort((a, b) => {
    const da = due(a);
    const db = due(b);
    return da === db ? 0 : da < db ? -1 : 1;
  });
  return { open, rest };
}
